// extracted by mini-css-extract-plugin
module.exports = {"TableTitle":"TableTitle_TableTitle__2Uj5P","arrows":"TableTitle_arrows__3NjD2","title":"TableTitle_title__16sYF"};